const DYSLEXIA_MODE_KEY = 'opac_dyslexia_mode_v1';

export function isDyslexiaModeEnabled() {
  try {
    return localStorage.getItem(DYSLEXIA_MODE_KEY) === '1';
  } catch (_error) {
    return false;
  }
}

export function setDyslexiaModeEnabled(enabled) {
  try {
    localStorage.setItem(DYSLEXIA_MODE_KEY, enabled ? '1' : '0');
  } catch (_error) {
    // Ignore storage failures (e.g. private browsing).
  }
  if (typeof document !== 'undefined') {
    document.body.classList.toggle('dyslexia-mode', Boolean(enabled));
  }
}
